import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShowIfHttpError } from '@certemy/common';
import { HttpService } from 'services/http/http.service';
import { OrgUserProfile } from 'interfaces/profile.interface';
import { buildQueryParams, createQueryParam } from 'utils/helpers';
import { map } from 'rxjs/operators';
import _orderBy from 'lodash-es/orderBy';
import { IManagers } from 'components/profile-card/profile-card.constant';

@Injectable()
export class ProfileCardService {
  constructor(private http: HttpService) {}

  @ShowIfHttpError('An error occurred while updating profile. Please, try again')
  updateProfessionalProfile(id, payload): Observable<OrgUserProfile> {
    return this.http.post(`/profile/general-info/${id}`, payload);
  }

  @ShowIfHttpError('An error occurred while getting managers')
  getManagers(filters = null, search = ''): Observable<IManagers[]> {
    const queryParams = buildQueryParams([createQueryParam('filters', filters), createQueryParam('search', search)]);
    return this.http.get(`/profile/possible-managers${queryParams}`).pipe(
      map(options => {
        const firstNameSorter = option => option.firstName.toLowerCase();
        const lastNameSorter = option => option.lastName.toLowerCase();
        return _orderBy(options, [firstNameSorter, lastNameSorter], ['asc', 'asc']);
      }),
    );
  }

  @ShowIfHttpError('An error occurred while checking locations')
  checkManagerLocations(id, payload) {
    return this.http.post(`/manager-validation/${id}/offices`, payload);
  }
}
